export default "__VITE_ASSET__76e795ef__"